import styled from 'styled-components'
import { backgroundOrange } from '@/theme/colors'

export const BoardContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	background-color: ${backgroundOrange};
	overflow: hidden;
`

export const ScrollableColumnsWrapper = styled.div`
	overflow-x: auto;
	overflow-y: hidden;
	flex: 1;
	min-height: 0;

	/* Custom scrollbar styling */
	&::-webkit-scrollbar {
		height: 8px;
	}

	&::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background: #d1d5db;
		border-radius: 4px;

		&:hover {
			background: #9ca3af;
		}
	}

	/* Firefox */
	scrollbar-width: thin;
	scrollbar-color: #d1d5db #f1f1f1;
`

export const ColumnsContainer = styled.div`
	display: flex;
	gap: 20px;
	min-width: fit-content;
	height: 100%;
	padding: 0 20px 20px 20px;
	align-items: flex-start;

	@media (max-width: 600px) {
		gap: 12px;
		padding: 0 12px 12px 12px;
	}
`
